
define('text!modules/audiences/pixels/templates/select_type.html',[],function () { return '<strand-dropdown placeholder="Event" fitparent class="select-filter select-type">\n\t<strand-list-item value="event">Event</strand-list-item>\n\t<strand-list-item value="data">Data</strand-list-item>\n</strand-dropdown>';});

